import MDEditor from "@uiw/react-md-editor";
import "./markdown-editor.css";

interface MarkdownEditorProps {
  value: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
}

export function MarkdownEditor({ value, onChange, readOnly }: MarkdownEditorProps) {
  const colorMode = document.documentElement.dataset.theme === "dark" ? "dark" : "light";

  return (
    <MDEditor
      value={value}
      onChange={(val) => onChange(val || "")}
      data-color-mode={colorMode}
      preview={readOnly ? "preview" : "live"}
      hideToolbar={readOnly}
      height="100%"
      style={{ minHeight: 300 }}
      textareaProps={{
        readOnly: readOnly,
      }}
    />
  );
}
